import * as React from 'react';

import { DocumentTitle, Spinner } from 'components/common';
import WizardPageHeader from 'components/authentication/directoryServices/ldap/WizardPageHeader';
import SectionComponent from 'components/common/Section/SectionComponent';
import LicenseCheck from 'license/LicenseCheck';
import getDisplayName from 'authentication/helpers/getDisplayName';
import SAMLBackendConfigWizard from 'authentication/components/saml/config/SAMLBackendConfigWizard';
import type { DirectoryServiceBackend } from 'logic/authentication/directoryServices/types';
import type AuthenticationBackend from 'logic/authentication/AuthenticationBackend';
import { fromAuthenticationBackend } from 'authentication/components/saml/config/helpers/samlConfigConverter';
import useSAMLTeamSyncConfig from 'authentication/components/saml/hooks/useSAMLTeamSyncConfig';

interface BackendEditProps {
  authenticationBackend: AuthenticationBackend;
  initialStepKey: string;
}

const SAMLBackendEdit = ({ authenticationBackend, initialStepKey }: BackendEditProps) => {
  const { isLoading, teamSyncBackend } = useSAMLTeamSyncConfig(authenticationBackend.id);

  if (authenticationBackend?.id && isLoading) {
    return <Spinner />;
  }

  const {
    config: { type: authServiceType },
  } = authenticationBackend;
  const title = `Edit ${getDisplayName(authServiceType)} Authentication Service`;

  // TODO: Adjust WizardPageHeader component to take more generic types so we don't have to type cast.
  return (
    <DocumentTitle title={title}>
      <WizardPageHeader authenticationBackend={authenticationBackend as unknown as DirectoryServiceBackend} />
      <SectionComponent title={title}>
        <LicenseCheck>
          {({ licenseIsValid }) => (
            <SAMLBackendConfigWizard
              authBackend={fromAuthenticationBackend(authenticationBackend, teamSyncBackend)}
              initialStep={initialStepKey}
              licenseIsValid={licenseIsValid}
            />
          )}
        </LicenseCheck>
      </SectionComponent>
    </DocumentTitle>
  );
};

export default SAMLBackendEdit;
